/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1082
 */

exports.f = Object.getOwnPropertySymbols
